<template>
  <div class="main-box main-min-height bgffffff" ref="main">
    <div class="table-box" style="">
      <div class="header">
        <el-row :gutter="12">
          <el-col :span="8">
            <div @click="handleGo('/management/NewOrder')">
              <el-card shadow="always" :body-style="{background:'#e64242',border:'none',color:'#fff',display:'flex',justifyContent:'space-between'}">
                <div class="paddingTB">待发货订单</div>
                <div class="paddingTB">{{infoTopData.StayDeliverGoodsCount}}</div>
              </el-card>
            </div>
          </el-col>
          <el-col :span="8">
            <div @click="handleGo('/Commodity/index')">
              <el-card shadow="always" :body-style="{background:'#11b95c',border:'none',color:'#fff',display:'flex',justifyContent:'space-between'}">
                <div class="paddingTB">上架中的商品</div>
                <div class="paddingTB">{{infoTopData.CommodityCount}}</div>

              </el-card>
            </div>
          </el-col>
          <el-col :span="8">
            <div @click="handleGo('/management/WxUser')">
              <el-card shadow="always" :body-style="{background:'#1f2d3d',border:'none',color:'#fff',display:'flex',justifyContent:'space-between'}">
                <div class="paddingTB">总用户数</div>
                <div class="paddingTB">{{infoTopData.TotalCount}}</div>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="centent">
        <div class="line"></div>
        <div>
          <el-date-picker @change="getInfoB" v-model="date" type="daterange" value-format='yyyy-MM-dd' format='yyyy-MM-dd' align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
          </el-date-picker>
        </div>
        <div class="line"></div>
        <div class="centent_Card">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>顾客</span>
              <!-- <el-button style="float: right; padding: 3px 0" type="text">查看</el-button> -->
            </div>
            <div class="paddingTB">
              <span>新增</span>
              <h3 style="float: right;">{{infoBData.newCustomersCount}}</h3>
            </div>
            <div class="paddingTB">
              <span>老顾客</span>
              <h3 style="float: right;">{{infoBData.OldCustomersCount}}</h3>
            </div>
          </el-card>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>下单</span>
            </div>
            <div class="paddingTB">
              <span>加入购物车</span>
              <h3 style="float: right;">{{infoBData.cartCount}}</h3>
            </div>
            <div class="paddingTB">
              <span>提交订单数/金额</span>
              <h3 style="float: right;">{{infoBData.orderNumberPrice}}</h3>
            </div>
          </el-card>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>支付</span>
            </div>
            <div class="paddingTB">
              <span>成交订单数</span>
              <h3 style="float: right;">{{infoBData.orderNumberPrice}}</h3>
            </div>
            <div class="paddingTB">
              <span>成交金额</span>
              <h3 style="float: right;">{{infoBData.dealPrice}}</h3>
            </div>
          </el-card>
        </div>
        <div class="line"></div>
        <div class="centent_Card">
          <el-card class="box-card_48">
            <div class="paddingTB">
              <span>客单价</span>
              <p style="float: right;">{{infoBData.perTicketSales}}</p>
            </div>
            <p class="tips">成交金额/成交订单数</p>
          </el-card>
          <el-card class="box-card_48">
            <div class="paddingTB">
              <span>下单转化率</span>
              <p style="float: right;">{{infoBData.NumberVisitorsCount}}</p>
            </div>
            <p class="tips">下单人数/访问人数</p>
          </el-card>
          <el-card class="box-card_48">
            <div class="paddingTB">
              <span>下单-支付转化率</span>
              <p style="float: right;">{{infoBData.orderPaymentConversionRate}}</p>
            </div>
            <p class="tips">支付人数/下单人数</p>
          </el-card>
          <el-card class="box-card_48">
            <div class="paddingTB">
              <span>支付人数/下单人数</span>
              <p style="float: right;">{{infoBData.paymentConversionRate}}</p>
            </div>
            <p class="tips">支付人数/下单人数</p>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      value: null,
      infoTopData: {
        CommodityCount: 0,
        StayDeliverGoodsCount: 0,
        TotalCount: 0,
      },
      infoBData: {
        newCustomersCount: 0,//新增客户
        OldCustomersCount: 0,//老客户
        cartCount: 0,//加入购物车的商品数量
        orderNumberPrice: 0,//提交订单数/金额
        dealOrderCount: 0,//成交订单数
        dealPrice: 0,//成交金额
        perTicketSales: 0,//客单价
        NumberVisitorsCount: 0,  //下单转化率
        orderPaymentConversionRate: null,  //下单-支付转化率
        paymentConversionRate: null, //支付转换率
      },
      date: [],
      infoBottomData: null,
      pickerOptions: {
        shortcuts: [
          {
            text: '昨日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, end]);
            }
          }
          , {
            text: '今日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          }
          , {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
      },
    };
  },
  computed: {},
  created() {
    this.getTodayDate()
  },
  mounted() {
    this.getInfo();
    this.getInfoB();
  },
  methods: {
    handleGo(url) {
      this.$router.push({ path: url })
    },
    getInfo() {
      this.$Home.homePageUpper().then(({ data }) => {
        if (data.code === 200) {
          Object.keys(this.infoTopData).forEach(item => this.infoTopData[item] = data.result[item])
        }
      })
    },
    getInfoB() {
      this.$Home.homePageLower({
        beginTime: this.date[0],
        endTime: this.date[1],
      }).then(({ data }) => {
        if (data.code === 200) {
          Object.keys(this.infoBData).forEach(item => this.infoBData[item] = data.result[item] || 0)
        }
      })
    },
    //获取当前日期
    getTodayDate() {
      //获取当前日期
      let date = new Date();
      //获取当前月份
      let nowMonth = date.getMonth() + 1;
      //获取当前是几号
      let strDate = date.getDate();
      //添加分隔符
      let separator = "-";
      //对月份进行处理，小于10的补0
      if (nowMonth >= 1 && nowMonth <= 9) {
        nowMonth = '0' + nowMonth
      }
      //对几号进行处理，小于10的补0
      if (strDate >= 1 && strDate <= 9) {
        strDate = '0' + strDate
      }
      //进行各部分分拼接
      let nowDate = date.getFullYear() + separator + nowMonth + separator + strDate;
      this.date = [nowDate, nowDate]
    },
  }
};
</script>

<style lang="scss" scoped>
.header {
  margin-bottom: 30px;
}
.centent {
}
.line {
  margin: 20px 0;
  border-top: 1px solid #d1dbe5;
}
.paddingTB {
  padding: 10px 0;
  font-size: 14px;
}
.tips {
  color: #8c939d;
  font-size: 13px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.centent_Card {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .box-card {
    box-sizing: border-box;
    width: 32%;
    margin-right: 17px;
  }
  .box-card_48 {
    width: 48%;
    box-sizing: border-box;
    margin-right: 17px;
    margin-bottom: 17px;
  }
}
</style>
